import React, { MouseEvent } from 'react';
import { Link } from 'react-router-dom';
import Button from 'shared/Button/Button';
import { Action, Item } from 'components/List/types';
import classNames from 'classnames';

type Props = {
  items: Item[];
  onClick: Action;
  hasGap: boolean;
  selectable: boolean;
  isSelected: boolean;
  onRowClick?: Action;
};

const ListRow: React.FC<Props> = ({ items, onClick, hasGap, selectable, isSelected, onRowClick }: Props) => {
  const actionClickHandler = (action?: Action) => {
    return (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      if (action) {
        onClick(action());
      }
    };
  };

  const tdClassName = classNames('tbody__td', {
    'tbody__td--gap': hasGap,
  });

  const trClassName = classNames('tbody__tr', {
    row__selectable: selectable,
    'row__selectable--selected': isSelected,
  });

  return (
    <>
      <tr key={JSON.stringify(items)} className={trClassName} onClick={selectable ? onRowClick : undefined}>
        {items.map((item, index: number) => (
          <td key={`${index}--${JSON.stringify(item)}`} className={tdClassName}>
            {item.action ? (
              <Button
                className="list-table__button"
                type="button"
                label={item.label}
                onClick={actionClickHandler(item.action)}
              />
            ) : item.link ? (
              <Link to={item.link.href}>{item.label}</Link>
            ) : (
              item.label
            )}
          </td>
        ))}
      </tr>
    </>
  );
};

export default ListRow;
